import { useQuery } from 'react-query'
import { getAllOrders } from '../..'
import { PaginatedRequest } from '../../../core/interfaces'
import { CustomersFilter } from '../../../entities'

export default function useOrders(query: PaginatedRequest<CustomersFilter>) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['orders', query],
    () => getAllOrders(query),
    {
      keepPreviousData: true
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
